import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/common/loader.service';
import { ToastrService } from 'ngx-toastr';
import { MedicalFileService } from '../medical.file.service';

@Component({
  selector: 'app-add-medical-care-plan',
  templateUrl: './add-medical-care-plan.component.html',
  styleUrls: ['./add-medical-care-plan.component.scss']
})
export class AddMedicalCarePlanComponent implements OnInit {
  addCarePlanTitle=false;
  editCarePlanTitle=false;
  careplanForm:FormGroup;
  submitted = false;
  carePlanTypes=[];
  medFileId;
  modalreference;
  @Output()
  carePlanAdded: EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder,private medicalFileService:MedicalFileService,private loaderService:LoaderService,private toasterService:ToastrService) {this.getFromGroup();}

  ngOnInit() {
    this.medicalFileService.getCarePlanTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.carePlanTypes = response['result'];
      }
    });
  }
  get f() { return this.careplanForm.controls; }

  /**
   * Declare form group
   *  
   */
  private getFromGroup() {
   this.careplanForm = this.formBuilder.group({
     'medcaId':[],
     'medcaVaPathology': new FormControl(),
     'medcaVaOrgan':new FormControl(),
     'medcaVaProcedure': new FormControl(),
     'medcaVaName': new FormControl(),
     'medcaVaTotalCost': new FormControl(),
     'catypId': new FormControl(),
     'pctypId': new FormControl(),
     'medcaVaProblem': new FormControl(),
     'medcaVaAssessment': new FormControl(),
     'medcaVaDifferentialDiagnoses': new FormControl(),
     'medcaVaEducation': new FormControl(),
     'medcaNuTotalDuration': new FormControl(),
     'statuCode': new FormControl(),
    'medcaVaComment': new FormControl(),
     'staRecCode': [true],
     'medfiId':[]
   })
 }
 save() {
  this.submitted = true;
  if (this.careplanForm.invalid) {
    return;
  }
  this.careplanForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
  if(this.medFileId){
    this.careplanForm.patchValue({ medfiId: this.medFileId});
  }
  let saveData = this.careplanForm.value;
  this.loaderService.display(true);
  this.medicalFileService.saveCarePlan(saveData).subscribe(response => {
    this.loaderService.display(false);
    if (response && response["code"]==0) {
      this.careplanForm.patchValue({medcaId: response['result']});
      this.toasterService.success(response['message'], 'Success');
      this.carePlanAdded.emit(response['result']);
    }else{
      this.toasterService.error(response['message'], 'Error');
      this.carePlanAdded.emit(null);
    }
  },
  error => {
    this.loaderService.display(false);
  })
}
clear(){
  this.careplanForm.reset();
}

}
